export function isJSONParsable(str) {
    return typeof str === 'string' && (str[0] === '[' || str[0] === '{');
}

export function isNonEmptyObject(value) {
    return (
        typeof value === 'object' &&
        value !== null &&
        !Array.isArray(value) &&
        Object.keys(value).length > 0 // Check if it has at least one own enumerable property
    );
}
